import autocomplete from 'devbridge-autocomplete';

export default function searchVehicle() {

    if ($('.search-form').length > 0) {
        let $searchForm = $('.search-form'),
            $searchInput = $('.search-form .search-input'),
            $searchInputWrap = $('.search-input__wrap'),
            $clearForm = $('._empty-input'),
            scrollTop = 0;

        // $('.modal--search').attr('data-enable-scroll', 'data-enable-scroll');
        $searchInput.on('click', function () {
            scrollTop = $(window).scrollTop();
            $searchForm.addClass('_active');
            if (window.innerWidth <= 768) {
                $searchForm.addClass('_mobile');
                $('.modal__close').css('position', 'static');
                $('.mobile-autocomplete').attr('data-enable-scroll', 'data-enable-scroll');
                setTimeout(function () {
                    $('html, body').animate({scrollTop : 0}, 150);
                },150);
            }
        });

        $searchInput.on('input blur', function () {
            if($(this).val().length) {
                $searchInputWrap.addClass('_active');
            } else if ($(".autocomplete-suggestions[style*='block']")) {
                $searchForm.addClass('_active');
            } else {
                $searchInputWrap.removeClass('_active');
            }
        });

        $clearForm.on('click', function () {
            $searchInput.val('');
            $searchInputWrap.removeClass('_active');
        });

        $(document).on('click', '._search-overlay, ._back', function (e) {
            $(window).scrollTop(scrollTop);
            $searchForm.removeClass('_active');
            $('.modal__close').css('position', 'absolute');
            $('.mobile-autocomplete').removeAttr('data-enable-scroll');
            if (e.which == 27) {
                $searchForm.removeClass('_active');
            }
        });

        $(document).on('keydown', function (e) {
            if (e.which == 27) {
                $searchForm.removeClass('_active');
            }
        });

        $(document).on('click', '._mobile-controls [data-modal-close]', function () {
            $(window).scrollTop(scrollTop);
            $searchForm.removeClass('_mobile');
            $searchForm.removeClass('_active');
            $('.modal__close').css('position', 'absolute');
            $('.mobile-autocomplete').removeAttr('data-enable-scroll');
            // $searchInput.val('');
        });

        if ($searchInput.val().length) {
            $searchInputWrap.addClass('_active');
        }

        $('.btn.btn--accent.btn--marked-l').on('click', function () {
            $(this).parents('form').submit();
        });
    }
}